module.exports = __webpack_public_path__ + "img/tag_front.4e186d02.svg";